const SkeletonLoading = () => (
  <div className="animate-pulse flex">
    <div className="h-4 md:h-5 rounded w-20 bg-grey-260" />
    <div className="h-4 md:h-5 rounded w-20 bg-grey-260 ml-3 md:ml-4" />
    <div className="h-4 md:h-5 rounded w-20 bg-grey-260 ml-4 md:block hidden" />
  </div>
);

export default SkeletonLoading;
